import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

const FrontWindowLength: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'one-half padding-right-m',
}) => {
  const { t } = useTranslation()
  return (
    <div className={`grid-item margin-top-l ${wrapperClassName}`}>
      <TextInput
        id='front-window-length'
        propertyName='frontWindowLength'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.frontWindowLength', 'FrontWindowLength')}</span>}
        value={insertionData.frontWindowLength}
        maxLength={6}
        type='text'
        affixRight='unit'
        unitRight='meters'
        errors={validationMessages!.frontWindowLength ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default FrontWindowLength
